import { render, staticRenderFns } from "./apiDocument.vue?vue&type=template&id=27681dcc&scoped=true"
import script from "./apiDocument.vue?vue&type=script&lang=js"
export * from "./apiDocument.vue?vue&type=script&lang=js"
import style0 from "./apiDocument.vue?vue&type=style&index=0&id=27681dcc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27681dcc",
  null
  
)

export default component.exports